<template>
  <button
    class="thumb-button"
    :class="thumbButtonClasses"
  >
    <span class="content">
      <slot></slot>
    </span>
  </button>
</template>

<script>
export default {
  name: 'ThumbButton',
  data () {
    return {
      active: false
    }
  },
  props: {
    negative: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    thumbButtonClasses () {
      return {
        'is-negative': this.negative,
        'is-positive': !this.negative
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.thumb-button {
  width: 58px;
  height: 58px;
  font-size: 0;
  text-align: center;
  position: relative;
  display: inline-block;
  padding: 0;
  outline: 0;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  will-change: opacity;
  transition: opacity 0.2s ease;
}

.content {
  font-size: 28px;
  position: absolute;
  transform: translateY(0px) scale(1);
  will-change: transform;
  transition: transform 0.2s ease;
}

.is-positive {
  background-color: #65C7C2;

  &:hover .content {
    transform: scale(1.05);
  }

  .content {
    top: 13px;
    left: 15px;
  }
}

.is-negative {
  background-color: #f66;

  &:hover .content {
    transform: scale(1.05);
  }

  .content {
    bottom: 9px;
    right: 15px;
  }
}
</style>
